if (!customElements.get("loading-main")) {
  class LandingMain extends HTMLElement {
    static Selectors = {
      categoryLink: "[js-category-link]",
      categoryBlock: "[js-category-block]",
      collectionLink: "[js-collection-link]",
      collectionBlock: "[js-collection-block]",
      grid: "[js-grid]",
      product: "[js-product]",
      addButton: "[js-add]",
      quantity: "[js-quantity]",
      barCount: "[js-bar-count]",
      barProducts: "[js-bar-products]",
      barPrice: "[js-bar-price]",
      barToggle: "[js-bar-toggle]",
      removeProduct: "[js-remove-product]",
      nextButton: "[js-next]",
      bar: "[js-bar]",
      barDiscount: "[js-bar-discount]",
      finishButton: "[js-finish]",
    };

    static ACTIVE_CLASS = "is-active";
    static OPEN_CLASS = "is-open";
    static ADDED_CLASS = "is-added";
    static BUTTON_AT_FINISH_CLASS = "at-finish";
    static BUTTON_HAS_PRODUCT_CLASS = "has-product";
    static FINISH_BUTTON_LAST_STEP_CLASS = "landing-main__bar-finish--primary";    

    static LOCAL_STORAGE_KEY = "selected_products";

    constructor() {
      super();

      this._products = [];
    }

    get products() {
      return this._products;
    }

    set products(value) {
      this._products = value;

      this.updateDynamicElements(value);

      localStorage.setItem(
        LandingMain.LOCAL_STORAGE_KEY,
        JSON.stringify(value)
      );
    }

    updateCountElement(products) {
      const count = products.reduce(
        (acc, product) => acc + product.item.quantity,
        0
      );
      this.countElement.innerHTML = this.countElement
        .getAttribute(count == 1 ? "data-one-text" : "data-other-text")
        .replace("{{ count }}", count);
    }

    updateDiscountElement(products) {
      const amount = products.reduce(
        (acc, product) => (product.discountValue * product.item.quantity) + acc,
        0
      );
      if (amount == 0) return (this.barDiscountElement.innerHTML = "");

      const value = this.currencyFormat.replace(
        "{{amount}}",
        amount.toFixed(2)
      );

      this.barDiscountElement.innerHTML = this.getAttribute(
        "data-discount-format"
      ).replace("{{ amount }}", value);
    }

    updatePriceElement(products) {
      this.priceElement.innerHTML = this.currencyFormat.replace(
        "{{amount}}",
        products
          .reduce(
            (acc, product) => acc + product.price * product.item.quantity,
            0
          )
          .toFixed(2)
      );
    }

    updateBarProducts(products) {
      this.barProductsElement.innerHTML = products
        .map((product, index) => {
          return `
          <div class="landing-main__bar-product" js-remove-product="${index}">
            <div class="landing-main__bar-product-image">
              <img src="${product.imageURL}" alt="${
            product.title
          }" width="auto" height="auto" loading="eager" />
            </div>

            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.3429 18.5426L17.6566 7.2289" stroke="rgb(var(--color-brand-red))" stroke-width="1.79263" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.32603 7.21236L17.6739 18.5602" stroke="rgb(var(--color-brand-red))" stroke-width="1.79263" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <p class="landing-main__bar-product-title">
              ${product.item.quantity > 1 ? product.item.quantity + "x" : ""} ${
            product.title
          }
            </p>
          </div>`;
        })
        .join("");
    }

    updateBarHeightVariable() {
      if (!this.barElement) return;

      window.setTimeout(
        () =>
          document.documentElement.style.setProperty(
            "--bar-height",
            this.barElement.clientHeight + "px"
          ),
        301
      );
    }

    updateDynamicElements(products) {
      this.updateProductCards(products);
      this.updateCountElement(products);
      this.updatePriceElement(products);
      this.updateDiscountElement(products);
      this.updateBarProducts(products);
      this.updateBarHeightVariable();

      if (!this.products.length) {
        this.barProductsElement.classList.remove(LandingMain.OPEN_CLASS);
      }

      this.updateNextButton();
      if (this.finishButton) {
        this.finishButton.classList.toggle("hidden", !products.length);
      }      
    }

    handleNextButtonAtLastIndex() {
      const lastCategoryActive = this.categoryLinks[
        this.categoryLinks.length - 1
      ]?.classList.contains(LandingMain.ACTIVE_CLASS);

      let atLastPill = true;
      const activeCategory = Array.from(this.categoryBlocks).find((category) =>
        category.classList.contains(LandingMain.ACTIVE_CLASS)
      );
      if (activeCategory) {
        const pills = activeCategory.querySelectorAll(LandingMain.Selectors.collectionLink);
        if (pills.length > 1) {
          const activeIdx = Array.from(pills).findIndex((a) =>
            a.classList.contains(LandingMain.ACTIVE_CLASS)
          );
          atLastPill = activeIdx !== -1 && activeIdx === pills.length - 1;
        }
      }

      const atFinish = lastCategoryActive && atLastPill;

      this.nextButton.classList.toggle(
        LandingMain.BUTTON_AT_FINISH_CLASS,
        atFinish
      );

      this.nextButton.classList.toggle('hidden', atFinish);
      this.nextButton.toggleAttribute("disabled", atFinish && !this.products.length);

      // 🔹 Add/remove custom class on Finish button at last step
      if (this.finishButton) {
        this.finishButton.classList.toggle(
          LandingMain.FINISH_BUTTON_LAST_STEP_CLASS,
          atFinish
        );
      }
    }


    handleNextButtonWithActiveProduct() {
      const activeCategory = Array.from(this.categoryBlocks).find((category) =>
        category.classList.contains(LandingMain.ACTIVE_CLASS)
      );
      if (!activeCategory) return;

      const addedProducts = activeCategory.querySelectorAll(`.${LandingMain.ADDED_CLASS}`);
      const atFinish = this.nextButton.classList.contains(LandingMain.BUTTON_AT_FINISH_CLASS);

      this.nextButton.classList.toggle(
        LandingMain.BUTTON_HAS_PRODUCT_CLASS,
        addedProducts.length && !atFinish
      );
    }


    updateNextButton() {
      this.handleNextButtonAtLastIndex();
      this.handleNextButtonWithActiveProduct();
    }

    handleTabs(target, links, blocks) {
      const targetId = target.getAttribute("href").replace("#", "");
      const targetBlock = Array.from(blocks).find(
        (block) => block.id == targetId
      );

      if (!targetBlock) return;

      Array.from(target.parentElement.children).forEach((link) =>
        link.classList.remove(LandingMain.ACTIVE_CLASS)
      );
      Array.from(targetBlock.parentElement.children).forEach((block) =>
        block.classList.remove(LandingMain.ACTIVE_CLASS)
      );

      target.classList.add(LandingMain.ACTIVE_CLASS);
      targetBlock.classList.add(LandingMain.ACTIVE_CLASS);
    }

    handleCategoryLinkClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const anchor = event.target.closest("a");

      // Activate the category tab
      this.handleTabs(
        anchor,
        this.categoryLinks,
        this.categoryBlocks
      );

      // NEW: when switching to a parent category, always load its FIRST pill/tab
      const categoryId = anchor.getAttribute("href").replace("#", "");
      const categoryBlock = Array.from(this.categoryBlocks).find(b => b.id === categoryId);
      if (categoryBlock) {
        const links  = categoryBlock.querySelectorAll(LandingMain.Selectors.collectionLink);
        const blocks = categoryBlock.querySelectorAll(LandingMain.Selectors.collectionBlock);
        if (links.length && blocks.length) {
          this.handleTabs(links[0], links, blocks); // force first pill active
        }
      }

      anchor.scrollIntoView({ inline: 'start', behavior: 'smooth', block: 'nearest' });
      this.updateNextButton();
    }
    
    handleCollectionLinkClick(event) {
      event.preventDefault();
      event.stopPropagation();

      this.handleTabs(
        event.target.closest("a"),
        this.collectionLinks,
        this.collectionBlocks
      );
      this.updateNextButton();
    }

    removeProduct(product) {
      product.elementRef.forEach((element) =>
        element.classList.remove(LandingMain.ADDED_CLASS)
      );
      product.quantityRef.forEach((quantity) => (quantity.value = 1));
      this.products = this.products.filter(
        (element) => element.item.id != product.item.id
      );
    }

    handleAddProduct(addButton) {
      const productElement = addButton.closest(LandingMain.Selectors.product);
      if (!productElement) return;
      const allDuplicatedProducts = this.querySelectorAll(
        `[js-id="${productElement.getAttribute("js-id")}"]`
      );
      const allQuantityElements = [];

      allDuplicatedProducts.forEach((product) => {
        const quantityElement = productElement.querySelector(
          'input[name="quantity"]'
        );

        allQuantityElements.push(quantityElement);

        productElement.classList.add(LandingMain.ADDED_CLASS);
      });

      const maxQuantity = Number(allQuantityElements[0]?.getAttribute("max"));
      const fixedQuantity = productElement.dataset.fixedQuantity === "true";

      const data = {
        discountValue: Number(
          productElement.getAttribute("data-discount-value") || 0
        ),
        elementRef: Array.from(allDuplicatedProducts),
        quantityRef: allQuantityElements,
        fixedQuantity,
        imageURL: productElement.getAttribute("data-product-image-url"),
        title: productElement.getAttribute("data-product-title"),
        price: Number(productElement.getAttribute("data-product-price")),
        maxQuantity,
        item: {
          id: Number(productElement.getAttribute("data-default-variant")),
          quantity: 1,
        },
      };

      const sellingPlan = productElement.getAttribute(
        "data-default-selling-plan"
      );

      if (sellingPlan) {
        data.item.selling_plan = Number(sellingPlan);
      }

      this.products = [...this.products, data];
    }

    updateProductQuantity(product, newQuantity) {
      if (product.fixedQuantity) {
        product.item.quantity = 1;
        this.products = [...this.products];
        return;
      }

      let value = newQuantity;
      if (product.maxQuantity <= newQuantity) value = product.maxQuantity;
      if (newQuantity == 0) return this.removeProduct(product);

      product.item.quantity = value;
      if (product.quantityRef) product.quantityRef.value = value;

      this.products = [...this.products];
    }

    handleQuantityChange(quantityButton) {
      const productElement = quantityButton.closest(
        LandingMain.Selectors.product
      );
      if (!productElement) return;

      const id = Number(productElement.getAttribute("data-default-variant"));

      this.products.forEach((product) => {
        if (product.item.id != id) return;

        this.updateProductQuantity(
          product,
          product.item.quantity +
            Number(quantityButton.getAttribute("data-action"))
        );
      });
    }

    handleToggleProductsBar(event) {
      event.preventDefault();
      if (!this.products.length) return;
      this.barProductsElement.classList.toggle(LandingMain.OPEN_CLASS);
      this.updateBarHeightVariable();
    }

    handleClick(event) {
      const quantityButton = event.target.closest("[data-action]");
      const addButton = event.target.closest("[js-add]");

      if (!quantityButton && !addButton) return;
      event.preventDefault();

      if (addButton) return this.handleAddProduct(addButton);
      if (quantityButton) return this.handleQuantityChange(quantityButton);
    }

    handleBarProductClick(event) {
      const closestProduct = event.target.closest(
        LandingMain.Selectors.removeProduct
      );
      if (!closestProduct) return;

      event.preventDefault();
      event.stopPropagation();

      this.removeProduct(
        this.products[closestProduct.getAttribute("js-remove-product")]
      );
    }

    updateProductCards(products) {
      products.forEach((product) => {
        const productElements = this.querySelectorAll(
          `[data-default-variant="${product.item.id}"]`
        );
        if (!productElements) return;

        const quantityElements = [];
        productElements.forEach((element) => {
          if (element.dataset.fixedQuantity === "true") {
            product.fixedQuantity = true;
            product.item.quantity = 1;
          }

          const quantity = element.querySelector('input[name="quantity"]');
          if (!quantity) return;
          quantity.value = product.item.quantity;

          quantityElements.push(quantity);
          element.classList.add(LandingMain.ADDED_CLASS);
        });

        product.elementRef = productElements;
        product.quantityRef = quantityElements;
      });
    }

    handleCachedProducts() {
      const cachedProducts = JSON.parse(
        localStorage.getItem(LandingMain.LOCAL_STORAGE_KEY)
      );
      if (!cachedProducts) return;

      this.products = cachedProducts;
    }

    handleSelectChange(event) {
      if (!event.target.hasAttribute("js-sort")) return;

      const collectionBlock = event.target.closest(
        LandingMain.Selectors.collectionBlock
      );
      if (!collectionBlock) return;

      const url = collectionBlock.getAttribute("data-url");
      if (!url) return;

      fetch(url + `?view=landing-grid&sort_by=${event.target.value}`)
        .then((res) => res.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const newGrid = html.querySelector(LandingMain.Selectors.grid);
          const currentGrid = collectionBlock.querySelector(
            LandingMain.Selectors.grid
          );

          if (!newGrid || !currentGrid) return;
          currentGrid.innerHTML = newGrid.innerHTML;

          this.products = [...this.products];
        })
        .catch((err) => console.log(err));
    }

    handleFinish(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!this.products.length) return;

      const formData = { items: this.products.map((product) => product.item) };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then(() => {
          localStorage.removeItem(LandingMain.LOCAL_STORAGE_KEY);
          this.products = [];
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

    handleNext(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!this.nextButton.classList.contains(LandingMain.BUTTON_AT_FINISH_CLASS)) {
        const activeCategory = Array.from(this.categoryBlocks).find((cat) =>
          cat.classList.contains(LandingMain.ACTIVE_CLASS)
        );
        if (activeCategory) {
          const pills = activeCategory.querySelectorAll(
            LandingMain.Selectors.collectionLink
          );
          if (pills.length > 1) {
            const activeIdx = Array.from(pills).findIndex((a) =>
              a.classList.contains(LandingMain.ACTIVE_CLASS)
            );
            if (activeIdx > -1 && activeIdx < pills.length - 1) {
              pills[activeIdx + 1].click();
              this.updateNextButton();
              return window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }
          }
        }
        for (let index = 0; index < this.categoryLinks.length; index++) {
          if (
            !this.categoryLinks[index].classList.contains(
              LandingMain.ACTIVE_CLASS
            )
          )
            continue;
          const next = this.categoryLinks[index + 1];
          if (next) next.click();
          break;
        }
        this.updateNextButton();
        return window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }

      // At finish state: behave like Finish button
      this.handleFinish();
    }

    connectedCallback() {
      this.categoryLinks = this.querySelectorAll(
        LandingMain.Selectors.categoryLink
      );
      this.categoryBlocks = this.querySelectorAll(
        LandingMain.Selectors.categoryBlock
      );
      this.collectionLinks = this.querySelectorAll(
        LandingMain.Selectors.collectionLink
      );
      this.collectionBlocks = this.querySelectorAll(
        LandingMain.Selectors.collectionBlock
      );

      this.categoryLinks.forEach((link) =>
        link.addEventListener("click", this.handleCategoryLinkClick.bind(this))
      );
      this.collectionLinks.forEach((link) =>
        link.addEventListener(
          "click",
          this.handleCollectionLinkClick.bind(this)
        )
      );

      this.barDiscountElement = this.querySelector(
        LandingMain.Selectors.barDiscount
      );
      this.barElement = this.querySelector(LandingMain.Selectors.bar);
      this.countElement = this.querySelector(LandingMain.Selectors.barCount);
      this.priceElement = this.querySelector(LandingMain.Selectors.barPrice);
      this.barProductsElement = this.querySelector(
        LandingMain.Selectors.barProducts
      );
      this.barToggle = this.querySelector(LandingMain.Selectors.barToggle);
      if (this.barToggle)
        this.barToggle.addEventListener(
          "click",
          this.handleToggleProductsBar.bind(this)
        );

      if (this.barProductsElement)
        this.barProductsElement.addEventListener(
          "click",
          this.handleBarProductClick.bind(this)
        );

      this.addEventListener("click", this.handleClick.bind(this));

      this.addEventListener("change", this.handleSelectChange.bind(this));

      this.currencyFormat = this.getAttribute("data-currency-format");

      this.nextButton = this.querySelector(LandingMain.Selectors.nextButton);
      if (this.nextButton)
        this.nextButton.addEventListener("click", this.handleNext.bind(this));

        this.finishButton = this.querySelector(LandingMain.Selectors.finishButton);
        if (this.finishButton)
          this.finishButton.addEventListener("click", this.handleFinish.bind(this));


      this.handleCachedProducts();

      this.updateBarHeightVariable();
    }
  }

  customElements.define("landing-main", LandingMain);
}
